














import Vue from 'vue';
import { IdDisplayName } from '../../types';
import * as utenteApi from '../../services/utente-api';

export default Vue.extend({
    data() {
        return {
            items: [] as IdDisplayName[],
            selectedValue: null as any,
            disabled: false as boolean,
            itemText: 'displayName',
            itemValue: 'id',
        };
    },
    props: {
        label: { required: true },
        clearable: { default: false },
        setDefault: { default: false },
        value: {},
    },
    computed: {},
    methods: {
        onChange(e: any) {
            this.$emit('input', e);
        },
        async loadItems() {
            this.items = await utenteApi.getAllTipi();
            if (
                this.setDefault &&
                this.items.length > 0 &&
                !this.selectedValue
            ) {
                this.selectedValue = this.items[0].id;
                this.onChange(this.selectedValue);
            }
            if (
                this.items.filter((item) => item.id === this.selectedValue)
                    .length === 0
            ) {
                this.selectedValue = null;
                this.onChange(this.selectedValue);
            }
            this.disabled = false;
        },
    },
    async created() {
        await this.loadItems();
    },
    watch: {
        value: {
            handler: function (val) {
                this.selectedValue = val;
            },
            immediate: true,
        },
    },
});
